import React from 'react';
import {
  SaveButton,
  CREATE,
  fetchEnd,
  fetchStart,
  showNotification,
  Create,
  refreshView
} from 'react-admin';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { FormSpy } from 'react-final-form';
import { withStyles } from '@material-ui/core/styles';

import dataProvider from '../../core/providers/IccUserDataProvider';
import InvestorDetails from '../investors/InvestorDetails';
import DialogTitleWithCloseButton from '../../core/components/DialogTitleWithCloseButton';
import SimpleFormWithSave from '../../core/components/form/SimpleFormWithSave';
import { getIcError } from '../../core/providers/utils';

const styles = () => ({
  fullWidth: {
    width: '100%'
  }
});

class InvestorCreateDialog extends React.Component {
  investorFormProps;

  state = {
    submitting: false
  };

  setInvestorFormProps = props => {
    this.investorFormProps = props;
  };

  handleSaveClick = event => {
    // Trigger a submit of our custom quick create/update form
    // This is needed because our modal action buttons are oustide the form
    this.investorFormProps.form.submit(event);
  };

  handleClose = () => {
    const { handleDialogToggle } = this.props;
    const { submitting } = this.state;
    if (submitting) return;
    this.investorFormProps.form.reset();
    handleDialogToggle();
  };

  handleSubmit = values => {
    const {
      fetchStart,
      fetchEnd,
      showNotification,
      handleDialogToggle,
      id,
      refreshView
    } = this.props;

    // Dispatch an action letting react-admin know a API call is ongoing
    fetchStart();
    this.setState({ submitting: true });

    // As we want to know when the new investor has been created in order to close the modal, we use the
    // dataProvider directly
    dataProvider(CREATE, 'investors', { data: values })
      .then(({ data }) => {
        //Create fundinvestors relation with the new created investor
        dataProvider(CREATE, 'fundinvestors', {
          data: { fundId: id, investorId: data.id }
        }).then(() => {
          refreshView();
          handleDialogToggle();
        });
      })
      .catch(error => {
        showNotification('ra.notification.server', 'error', {
          messageArgs: { message: getIcError(error) }
        });
      })
      .finally(() => {
        // Dispatch an action letting react-admin know a API call has ended
        this.investorFormProps.form.reset();
        fetchEnd();
        this.setState({ submitting: false });
      });
  };

  render() {
    const {
      showDialog,
      showNotification,
      fetchStart,
      fetchEnd,
      classes,
      refreshView,
      ...createProps
    } = this.props;
    const { submitting } = this.state;

    return (
      <Dialog
        fullWidth
        open={showDialog}
        aria-label={`Create new investor`}
        maxWidth="md"
        onClose={(event, reason) => {
          if (reason === 'backdropClick') return null;
          this.handleClose();
        }}
      >
        <DialogTitleWithCloseButton onClose={this.handleClose}>
          Create new investor
        </DialogTitleWithCloseButton>
        <DialogContent>
          {/* Override record object that contains investor information */}
          <Create {...createProps} record={{}} className={classes.fullWidth}>
            <SimpleFormWithSave
              toolbar={null}
              resource="investors"
              onSave={this.handleSubmit}
              variant="standard"
              margin="normal"
            >
              <FormSpy>
                {props => {
                  this.setInvestorFormProps(props);
                  return <InvestorDetails creation={true} />;
                }}
              </FormSpy>
            </SimpleFormWithSave>
          </Create>
        </DialogContent>
        <DialogActions>
          <SaveButton
            saving={submitting}
            handleSubmitWithRedirect={this.handleSaveClick}
            label="Create and Add"
            icon={<></>}
          />
          <Button
            onClick={this.handleClose}
            variant="outlined"
            color="primary"
            disabled={submitting}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = {
  fetchEnd,
  fetchStart,
  showNotification,
  refreshView
};

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(InvestorCreateDialog));
